import {useEffect, useState} from 'react';

import {RunDiff, RunSelectorRunsQuery} from '../../../generated/graphql';
import {parseGqlDeltaOp} from '../../../state/runs-low/api';
import {fromServerResult} from '../../../state/runs-low/serverQuery_serverDelta';
import * as Run from '../../../util/runs';

/**
 * Processes run deltas (AKA {@link RunDiff}s) into an ordered list
 * of parsed {@link Run.Run} objects. When new deltas are received,
 * they will be parsed and merged into the available runs data.
 */
export const useRunDeltas = (data?: RunSelectorRunsQuery) => {
  const unprocessedData = data?.project?.runs;
  const [processedData, setProcessedData] = useState({
    totalRuns: 0,
    runs: [] as Run.Run[],
    lastUpdatedAt: new Date(0).toISOString(),
  });

  useEffect(() => {
    if (unprocessedData) {
      setProcessedData(existingData => {
        const incomingData = {
          delta: unprocessedData.delta.map(d => parseGqlDeltaOp(d as RunDiff)),
          totalRuns: unprocessedData.totalCount,
        };
        return fromServerResult(incomingData, existingData);
      });
    }
  }, [unprocessedData]);

  return processedData;
};
